import React, { PropsWithChildren } from "react";
import { ViewStyle } from "react-native";
import { TouchableBox } from "../AHTheme/Box";

export type WidgetProps = {
  style?: ViewStyle;
  title: string;
  onPress?: () => void;
  onLongPress?: () => void;

  disabled?: boolean;
  TitleElement?: React.ReactElement;
  backgroundColor?: string;
} & WidgetContainerProps;

export type WidgetContainerProps = PropsWithChildren<{
  onPress?: () => void;
  backgroundColor?: string;
}>;

export const AHWidget: React.FC<WidgetContainerProps> = ({
  children,

  onPress,
}) => {
  return (
    <TouchableBox
      disabled={!onPress}
      onPress={onPress}
      style={{
        overflow: "hidden",
        height: "100%",
        width: "100%",
      }}
      color="surface"
    >
      {children}
    </TouchableBox>
  );
};
